import React, { useEffect, useState } from 'react'
import { Input, Label } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'
import { Link, useNavigate } from 'react-router-dom'
import OTPInput from '../../../components/common/OtpInput'
import SetPasswordForm from '../components/SetPasswordForm'
import { usePassword } from '../core/usePassword'
import { IoEye, IoEyeOff } from 'react-icons/io5'
import { useMainContext } from '../../../modules/Dashboard'
import { BiEdit } from 'react-icons/bi'
import LockIcon from '../../../components/icons/LockIcon'

const AuthOtpPage = ({
    inputValues,
    otpInputRef,
    verifyCode,
    onVerifyCodeChange,
    timer,
    onOtpResend,
    verifyData,
    authCode,
    setAuthCode,
    password,
    setPassword,
    setValidationStatus,
    onPasswordChange,
    otpData
}) => {
    const navigate = useNavigate()
    const { shouldSetPassword, canLoginWithPassword } = usePassword({ ...otpData?.data })
    const [showPassword, setShowPassword] = useState(false)
    const togglePassword = () => setShowPassword(prev => !prev)
    const { main: { lang } } = useMainContext()


    useEffect(() => {
        if (!otpData?.data) {
            navigate('/auth/signin')
        }
    }, [otpData])

    return (
        <div className='flex flex-col gap-2'>
            {
                shouldSetPassword &&
                <>
                    <div className='space-y-2 w-full mt-4'>
                        <OTPInput
                            singleField
                            ref={otpInputRef}
                            value={verifyCode}
                            autoFocus={true}
                            onOtpChange={onVerifyCodeChange}
                            timer={timer}
                            onOtpResend={onOtpResend}
                        />
                        <Label className='!flex-col items-start'>
                            <Text tid={'code-sent_part-1'} className='text-secondaryColor' />
                            <span className='text-base text-secondaryColor font-semibold'>{inputValues.mobileOrEmail}</span>
                        </Label>

                    </div>
                    <SetPasswordForm
                        setValidationStatus={setValidationStatus}
                        password={password}
                        onPasswordChange={setPassword}
                    />
                </>
            }
            {verifyData?.data?.data?.authenticator && (
                <div className='flex flex-col gap-2 '>
                    <Label htmlFor='ga'>
                        <Text tid='google-verify' />
                    </Label>
                    <Input
                        id='ga'
                        status={
                            authCode.length === 0 ? 'normal' : authCode.length === 6 ? 'valid' : 'error'
                        }
                        maxLength={6}
                        onChange={(e) => setAuthCode(e?.target?.value)}
                        value={authCode}
                        autoFocus
                    />
                </div>
            )}
            {
                canLoginWithPassword &&
                <>
                    <div className='flex flex-col gap-2 mt-4'>
                        <Label >
                            <LockIcon size={16} color='#8481BD' />

                            <Text tid={"password"} className='text-inherit' />
                        </Label>
                        <div className='relative '>
                            <Input
                                autoFocus
                                name='password'
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={e => onPasswordChange(e.target.value)}
                                placeholder={lang === 'fa' ? "رمز عبور خود را وارد کنید" : "Enter your password"}
                            />
                            <button
                                type="button"
                                onClick={togglePassword}
                                className={`absolute top-1/2 -translate-y-1/2 text-xs ${lang === 'fa' ? "left-3" : "right-3"}`}
                            >
                                {showPassword ? <IoEye className='text-textDark dark:text-textLight' size={22} /> : <IoEyeOff className='text-textDark dark:text-textLight' size={22} />}
                            </button>
                        </div>
                        <Link to={'/auth/forget-password'} className='cursor-pointer  text-sm mt-2 mr-auto' >
                            <Text tid={'forget-password'} className='hover:text-mainColor' />
                        </Link>
                    </div>
                </>
            }
        </div>
    )
}

export default AuthOtpPage